import React, { useState, useEffect } from 'react';
import { Dropdown, Input } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const MySKU = ({
  field: { name },
  form: { setFieldValue },
  disabled,
  ...props
}) => {
  const [contents, setcontents] = useState([])
  const [isloading, setisloading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [initialValue, setInitalValue] = useState(props.initValue || '')
  const [options, setOptions] = useState([props.defOption] || [])
  const [touched, setTouched] = useState(false)

  useEffect(() => {
    if(!disabled && searchTerm.length > 2) {
      let locations = ReadAxios({ url: 'skuMaster', readItems: {searchTerm} }) || [];
      locations.then((res) => {
        setcontents(res.data.resultSet)
        setisloading(false)
      })
    } else {
      setisloading(false)
    }
  }, [searchTerm])

  useEffect(() => {
    let options = []
    if (contents.length > 0) {
      contents.map((object, index) => {
        let temp = {}
        temp.key = index + 1
        temp.text = `${object.skuName} (${object.skuCode})`
        temp.value = object.skuName
        return options[index] = temp
      })
    }
    setOptions(options)

  }, [contents])

  return touched ? (
    <Dropdown
      search
      selection
      loading={isloading}
      style={{ width: "100%" }}
      onSearchChange={(value, data) => {
        setSearchTerm(data.searchQuery)
      }}
      onChange={(value, data) => {
        setInitalValue('')
        setFieldValue(name, data.value)
        if (props?.categoryFieldName) {
          contents.forEach(element => {
            if (element.skuName == data.value) {
              setFieldValue(props.categoryFieldName, element.skuTypeId)
              setFieldValue(props.categoryKeyName, element.skuTypeName)
            }
          });
        }
        if (props?.codeFieldName) {
          contents.forEach(element => {
            if (element.skuName == data.value) {
              setFieldValue(props.codeFieldName, element.skuCode)
            }
          });
        }
      }}
      options={options}
      disabled={disabled}
      {...props}
    /> 
  ) : (
    <Input
      value={props.value}
      onClick={() => setTouched(true)}
    />
  )
    

}

export default MySKU